import $ from 'jquery';
import '../../../assets/js/features/excel'
import { createOrder } from '../../../assets/js/services/cartApi'
import { moveProducts, getTotalInfoByArticleList } from '../../../assets/js/features/product/services/ProductService'
import { eventSelectedProducts, parseProductQuantity, cartTrackFixedElements } from '../../../assets/js/features/cart/ui/cartUi';
import { fillSummaryInMoveProducts } from '../../../assets/js/features/cart/ui/templateFillers';
import { emit } from '../../../assets/js/core/eventBus'
import EVENTS from '../../../assets/js/core/events'
import { escapeAttrValue } from '../../../assets/js/utils/selector'

const notify = message => {
  if (typeof window.appNotify === 'function') {
    window.appNotify(message)
    return
  }

  window.alert(message)
}

const showModal = element => {
  const Modal = window.appBootstrapModal
  if (!Modal || !element) {
    return
  }

  Modal.getOrCreateInstance(element).show()
}

const hideModal = element => {
  const Modal = window.appBootstrapModal
  if (!Modal || !element) {
    return
  }

  Modal.getOrCreateInstance(element).hide()
}

const collectVisibleOrderArticles = () => {
  const articles = []
  $('#deliveryList .product-item:not(.d-none)').each(function () {
    const article = String($(this).data('id') || '')
    if (article && !articles.includes(article)) {
      articles.push(article)
    }
  })

  return articles
}

$(document).ready(function () {

  // Чекбокс выбора/снятия выбора всех товаров в корзине
  // Обновление состояния кнопок при выборе каждого товара корзины
  $('#cart-select-all').click( eventSelectedProducts );

  // Удаление недоступных товаров для выбранной даты доставки (кнопка удаления группы)
  $(document).on('click', '[data-clear-cart-group]', event => {
    event.preventDefault()
    const qtySel = '.product-item-quantity input';

    $(event.currentTarget).closest('.cart-group').find('.product-item').each(function () {
      const article = $(this).data('id')
      const quantity = parseProductQuantity( $( `[data-fulldate] [data-id="${escapeAttrValue(article)}"] ${qtySel}` ));

      emit(EVENTS.PRODUCT_REMOVED, {
        article: $(this).data('id'),
        delivery: $(this).data('delivery'),
        quantity: quantity,
      });
    })
  });

  // Удаление выбранных товаров из корзины (элементы скрываются, а не удаляются из дерева документа)
  $(document).on('click', '[data-clear-cart-selected]', event => {
    event.preventDefault()

    $('#cart-select-all').prop('checked', false)

    let articleIds = [];
    let quantities = [];

    $(document).
      find('.cart-group .product-item[data-basic="1"]:has( .form-check-input:checked )').
      each(function () {
        const article = $(this).data('id')
        const elDelivery = $(this).closest('data-fulldate');
        const qtySel = '.product-item-quantity input';

        const quantity = parseProductQuantity( $( `.cart-group [data-id="${escapeAttrValue(article)}"] ${qtySel}` ));

        articleIds.push( article );
        quantities.push( quantity );

        emit(EVENTS.PRODUCT_REMOVED, {
          article: article,
          delivery: elDelivery.data('fulldate'),
          quantity: quantity,
        });
      })

    emit(EVENTS.CART_DELETE_PRODUCTS, { articleIds, quantities });
  })

  // При клике на кнопку открытия модалки перемещения — пересчитываем сводку по отмеченным чекбоксам
  $(document).on('click', '[data-bs-target="#cart_move_modal"]', () => {
    const checkedArticles = []
    $('#deliveryList .cart-group .product-item:not(.d-none)').each(function () {
      const checkbox = $(this).find('.form-check-input')
      const article = String($(this).attr('data-id'))
      if (checkbox.prop('checked') && article && !checkedArticles.includes(article)) {
        checkedArticles.push(article)
      }
    })
    fillSummaryInMoveProducts( getTotalInfoByArticleList(checkedArticles) )
  })

  // Перемещение товаров
  $('#cart_move_modal .modal-footer input').click(event => {
    event.preventDefault()

    const contractorId = parseInt(
      $('#move_counterparty option:selected').val(),
    )

    moveProducts(contractorId)
  })

  $('#deliveryList').on('click', '[data-button-remove]', event => {
    event.preventDefault()

    // Удаление через обновление количества
    const self = $(event.currentTarget)
    const prodItem = $(self).closest('.product-item');
    const productId = prodItem.data('id');
    const qtySel = '.product-item-quantity input';

    const isBasic = prodItem.attr('data-basic') == 1;

    if( isBasic ) {

        const amount = parseProductQuantity( $( `[data-fulldate] [data-id="${escapeAttrValue(productId)}"] ${qtySel}` ));
        emit(EVENTS.PRODUCT_REMOVED, {
          article: productId,
          quantity: amount,
        });

        emit(EVENTS.CART_DELETE_PRODUCTS, {
          articleIds: [ productId ],
          quantities: [ amount ],
        });

    } else {

      const amount = parseProductQuantity( prodItem.find( qtySel ));
      let productQuantity = 0;
      $( `[data-delivery][data-id="${escapeAttrValue(productId)}"] ${qtySel}` ).each( function() {
        productQuantity += parseProductQuantity( $(this) );
      });

/*      emit(EVENTS.PRODUCT_REMOVED_DELIVERY, {
        article: productId,
        quantity: amount,
      });*/
      emit(EVENTS.CART_CHANGE_AMOUNT, {
        article: productId,
        quantity: productQuantity - amount,
      });
    }

  })

  $('#deliveryListOutOfStock').on('click', '[data-button-remove]', event => {
    event.preventDefault()

    const $card = $(event.currentTarget).closest('.product-item');
    const productId = $card.data('id');
    const rawAmount = parseInt($card.attr('data-amount'), 10);
    const originalAmount = Number.isFinite(rawAmount) && rawAmount >= 0 ? rawAmount : 1;

    emit(EVENTS.CART_DELETE_PRODUCTS, {
      articleIds: [ productId ],
      quantities: [ originalAmount ],
    });

    // Локально проставляем amount=0 (skipApi: out-of-stock товар отвергается
    // /api/cart/update_amount/ с 422). Это синхронизирует store и триггерит
    // CART_RENDER — карточка корректно исчезнет из OOS-блока.
    emit(EVENTS.CART_CHANGE_AMOUNT, {
      article: productId,
      quantity: 0,
      skipApi: true,
    });
  })

 $('[data-remove-uploaded]').click(function (e) {
    e.preventDefault()
    $(this).closest('.card').remove()
  })

  cartTrackFixedElements()

  const $checkoutConfirmModal = $('#checkout_confirm_order_modal')
  const checkoutConfirmModal = document.getElementById('checkout_confirm_order_modal')
  const $checkoutConfirmCheckboxes = $checkoutConfirmModal.find('.js-checkout-confirm')
  const $checkoutOrderConditions = $checkoutConfirmModal.find('.js-checkout-order-condition')
  const $confirmCreateOrderButton = $('#btn_confirm_create_order')

  const updateConfirmCreateOrderButtonState = () => {
    const $requiredCheckboxes = $checkoutConfirmCheckboxes.filter(':not(:disabled)')
    const allChecked = $requiredCheckboxes.length > 0 &&
      $requiredCheckboxes.toArray().every(checkbox => checkbox.checked)

    $confirmCreateOrderButton.prop('disabled', !allChecked)
  }

  const updateCheckoutConfirmConditions = () => {
    const hasOrderProducts = $('#deliveryList .product-item:not(.d-none)[data-order-stock="1"]').length > 0
    const $orderCheckboxes = $checkoutOrderConditions.find('.js-checkout-confirm')

    $checkoutOrderConditions.toggleClass('d-none', !hasOrderProducts)
    $orderCheckboxes
      .prop('disabled', !hasOrderProducts)
      .prop('checked', false)

    updateConfirmCreateOrderButtonState()
  }

  $checkoutConfirmCheckboxes.on('change', updateConfirmCreateOrderButtonState)
  checkoutConfirmModal?.addEventListener('hidden.bs.modal', () => {
    $checkoutConfirmCheckboxes.prop('checked', false)
    updateConfirmCreateOrderButtonState()
  })

  checkoutConfirmModal?.addEventListener('show.bs.modal', updateCheckoutConfirmConditions)

  $confirmCreateOrderButton.click(event => {
    event.preventDefault()

    const button = event.currentTarget
    const $requiredCheckboxes = $checkoutConfirmCheckboxes.filter(':not(:disabled)')
    const allChecked = $requiredCheckboxes.length > 0 &&
      $requiredCheckboxes.toArray().every(checkbox => checkbox.checked)

    if (!allChecked) {
      updateConfirmCreateOrderButtonState()
      return
    }

    button.disabled = true
    let orderCreated = false

    createOrder(collectVisibleOrderArticles())
      .then(data => {
        if (data?.ok) {
          orderCreated = true
          hideModal(document.getElementById('checkout_confirm_order_modal'))

          const orderPlacedModal = document.getElementById('order_placed_modal')
          showModal(orderPlacedModal)

          return
        }

        notify(data?.message || 'Не удалось оформить заказ')
      })
      .catch(error => {
        notify(error.response?.data?.message || error.response?.data?.error || 'Не удалось оформить заказ')
      })
      .finally(() => {
        if (!orderCreated) {
          button.disabled = false
        }
      })
  })

})
